// extracted by mini-css-extract-plugin
export default {"icons":"SWbJL","iconWrapper":"JFUkI","socialIcon":"NGir0"};